<template>
  <div class="no-gutters mr-0 pr-0">
    <table class="table-bordered table-evaluation-info">
      <tr>
        <td>
          <div class="mt-3">
            <p class="font-weight-bold mb-0">{{$t('medium_grant_ev.esms__info_risk_assessment')}}</p>
            <div class="mt-3">
              <radio name="model.info_risk_assessment"
                     class="form-check-inline"
                     value="verified"
                     v-model="EvaluationForm.model.info_risk_assessment"
              >
                <label>{{$t('medium_grant_ev.esms__info_low')}}</label>
              </radio>
            </div>
            <div>
              <radio name="model.info_risk_assessment"
                     class="form-check-inline"
                     value="unverifiable"
                     v-model="EvaluationForm.model.info_risk_assessment"
              >
                <label>{{$t('medium_grant_ev.esms__info_medium')}}</label>
              </radio>
            </div>
            <div>
              <radio name="model.info_risk_assessment"
                     class="form-check-inline"
                     value="clarification"
                     v-model="EvaluationForm.model.info_risk_assessment"
              >
                <label>{{$t('medium_grant_ev.esms__info_high')}}</label>
              </radio>
            </div>
          </div>
        </td>
      </tr>
      <!--<tr v-if="!EvaluationForm.evaluation.admin_user_id && loggedUser.role === UserRoles.ADMIN">-->
        <!--<td>-->
          <!--<div class="mt-3">-->
            <!--<p class="font-weight-bold mb-0">{{$t('medium_grant_ev.general__info_admin_decission')}}</p>-->
            <!--<div class="mt-3">-->
              <!--<base-button-->
                <!--class="mb-1"-->
                <!--type="info"-->
                <!--size="sm"-->
                <!--@click="validateEvaluation"-->
              <!--&gt;-->
                <!--{{$t('medium_grant_ev.general__admin_validate_cta')}}-->
              <!--</base-button>-->
            <!--</div>-->
          <!--</div>-->
        <!--</td>-->
      <!--</tr>-->
      <tr>
        <td>
          <div class="mt-3">
            <p class="font-weight-bold mb-3">{{$t('medium_grant_ev.general__info_grid_by')}}</p>
            <div v-if="EvaluationForm.evaluation && EvaluationForm.evaluation.user">
              <div>{{EvaluationForm.evaluation.user.name}}</div>
              <small>{{EvaluationForm.evaluation.updated_at}}</small>
            </div>
            <div v-else>-</div>
          </div>
        </td>
      </tr>
      <!--<tr>-->
        <!--<td>-->
          <!--<div class="mt-3">-->
            <!--<p class="font-weight-bold mb-3">{{$t('medium_grant_ev.general__info_grid_validated_by')}}</p>-->
            <!--<div v-if="EvaluationForm.evaluation && EvaluationForm.evaluation.admin && EvaluationForm.evaluation.admin_validation_at">-->
              <!--<div>{{EvaluationForm.evaluation.admin.name}}</div>-->
              <!--<small>{{EvaluationForm.evaluation.admin_validation_at}}</small>-->
            <!--</div>-->
            <!--<div v-else>-</div>-->
          <!--</div>-->
        <!--</td>-->
      <!--</tr>-->
    </table>
  </div>
</template>
<script>
  import {EvaluationForm, UserRoles} from "@/services";

  export default {
    data() {
      return {
        EvaluationForm,
        UserRoles,
        loggedUser: {}
      }
    },
    inject: ['validateEvaluation'],
    mounted() {
      let vm = this;
      vm.loggedUser = vm.$store.getters['Auth/loggedUser'];
    }
  }
</script>